import { getAuthHeaders, tempMeeApi } from '~/services/api';
import { ICreateDraftJobPostApiResponse, ICreateDraftJobPostPayload } from '../types';

export const createDraftJobPost = async ({
  isOfficeSelected,
}: ICreateDraftJobPostPayload): Promise<ICreateDraftJobPostApiResponse> => {
  const headers = await getAuthHeaders();

  const response = await tempMeeApi.post<ICreateDraftJobPostApiResponse>(
    '/posting-service/postings',
    {
      officeSelected: isOfficeSelected,
    },
    { headers },
  );

  return response.data;
};
